// extracted by mini-css-extract-plugin
export default {"PriceRangeFilter":"PriceRangeFilter-styles__PriceRangeFilter__UZv8F","PriceRangeFilter__Actions":"PriceRangeFilter-styles__PriceRangeFilter__Actions__SkaET"};